import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import SnackbarComponent from '../../../utils/employer/snackbarComponent.utils'
import DialogBox from '../../../utils/employer/dialogComponent.utils'
import { scrollToTop } from '../../../utils/scrollTo'
import NavButton from './navButton.component'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import FavoriteLightEntrepreneursComponent from './favoriteLightEntrepreneurs.component'
import AllLightEntrepreneursComponent from './allLightEntrepreneurs.component'
import {
  convertToObjects,
  createLinkArray
} from '../../../utils/openForWork.utils'
import PreviewOpenForWorkProfile from '../../openforwork/previewOpenForWorkProfile.component'
import { stringToArray } from '../../../utils/employer/stringArrayHandle.utils'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CloseIcon } from '../../openforwork/closeIcon.component'

/**
 * @author Huong Nguyen
 */

class LightEntrepreneursComponent extends React.Component {
  componentDidMount() {
    this.props.getAreaOfWork()
    this.props.getLightEntrepreneurs()
    this.props.getTotalApplications()
    scrollToTop()
  }

  render() {
    return <LightEntrepreneurs {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  previewLabel: {
    color: 'grey'
  },
  previewValue: {
    fontWeight: 500
  },
  links: {
    display: 'flex'
  },
  link: {
    width: '200px'
  }
})

const LightEntrepreneurs = ({
  classes,
  lightEntre,
  showSuccessAddSnackbar,
  showFailedAddSnackbar,
  closeLightEntrepreneursSnackbar,
  showEmailAdded,
  showEmailNotExist,
  offerAnAssignmentAgreement,
  setFavouriteEntrepreneurs,
  showAddFavouriteEntrepreneursFailedSnackbar,
  showRemoveFavouriteEntrepreneursFailedSnackbar,
  getLightEntrepreneurs,
  selectedLERatings
}) => {
  const history = useHistory()
  // const blank_picture = '../../../images/blank-profile-picture.png'
  const [previewForm, setPreviewForm] = React.useState(false)
  const [selectedLightEntrepreneur, setSelectedLightEntrepreneur] =
    React.useState({})
  const [entrepreneurList, setEntrepreneurList] = React.useState('buttonAll')
  const favouriteEntrepreneurs = lightEntre.filter(
    (el) => el.pinned_fav_lightentrepreneur === true
  )

  const handleLightEntrepreneurPreview = (id) => {
    setPreviewForm(true)
    const selectedItem = lightEntre.find((item) => item.Id === id)
    setSelectedLightEntrepreneur(selectedItem)
    getLightEntrepreneurs(selectedItem.email)
  }

  const handleCloseLightEntrepreneurPreview = () => {
    setPreviewForm(false)
    setSelectedLightEntrepreneur({})
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <NavButton
              t={t}
              entrepreneurList={entrepreneurList}
              setEntrepreneurList={setEntrepreneurList}
            />
            <div className="container">
              {entrepreneurList === 'buttonFavorites' ? (
                <FavoriteLightEntrepreneursComponent
                  lightEntre={favouriteEntrepreneurs}
                  classes={classes}
                  entrepreneurList={entrepreneurList}
                  handleLightEntrepreneurPreview={
                    handleLightEntrepreneurPreview
                  }
                  setFavouriteEntrepreneurs={setFavouriteEntrepreneurs}
                />
              ) : null}
              {entrepreneurList === 'buttonAll' ? (
                <AllLightEntrepreneursComponent
                  lightEntre={lightEntre}
                  classes={classes}
                  entrepreneurList={entrepreneurList}
                  handleLightEntrepreneurPreview={
                    handleLightEntrepreneurPreview
                  }
                  setFavouriteEntrepreneurs={setFavouriteEntrepreneurs}
                />
              ) : null}

              <Dialog
                open={previewForm}
                fullWidth
                maxWidth="md"
                onClose={handleCloseLightEntrepreneurPreview}
              >
                <CloseIcon
                  fontSize="large"
                  onClick={() => handleCloseLightEntrepreneurPreview()}
                />
                <DialogTitle id="alert-dialog-title">
                  <div
                    style={{
                      textAlign: 'center',
                      color: '#000000',
                      fontSize: '15px'
                    }}
                  >
                    {t('employer.lightEntrepreneurs.dialogTitle5')}
                  </div>
                </DialogTitle>
                <DialogContent>
                  <PreviewOpenForWorkProfile
                    t={t}
                    classes={classes}
                    formValues={selectedLightEntrepreneur}
                    profile_pic={selectedLightEntrepreneur?.user_profile_path}
                    userData={selectedLightEntrepreneur}
                    applicant_name={
                      selectedLightEntrepreneur?.firstname +
                      ' ' +
                      selectedLightEntrepreneur?.lastname
                    }
                    applicant_email={selectedLightEntrepreneur?.email}
                    applicant_phone_no={selectedLightEntrepreneur?.phone}
                    portfolios={convertToObjects(
                      selectedLightEntrepreneur?.user_portfolio_path
                    )}
                    AreaOf_Expertise={stringToArray(
                      selectedLightEntrepreneur?.AreaOfExpertise !== null
                        ? selectedLightEntrepreneur?.AreaOfExpertise
                        : ''
                    )}
                    role_title={selectedLightEntrepreneur?.Title}
                    short_des={selectedLightEntrepreneur?.ShortDescription}
                    inputCV={selectedLightEntrepreneur?.user_cv_path}
                    CV_file={selectedLightEntrepreneur?.user_cv_title}
                    linkRow={createLinkArray(
                      selectedLightEntrepreneur?.merged_porttitles !== null &&
                        selectedLightEntrepreneur?.merged_porttitles !==
                          undefined
                        ? selectedLightEntrepreneur.merged_porttitles
                        : '',
                      selectedLightEntrepreneur?.merged_urls !== null &&
                        selectedLightEntrepreneur?.merged_urls !== undefined
                        ? selectedLightEntrepreneur?.merged_urls
                        : ''
                    )}
                    work_experience={
                      selectedLightEntrepreneur?.Responsibilities
                    }
                    avg_rating_le={selectedLightEntrepreneur?.avg_rating_le}
                    info_consent_allowed={
                      selectedLightEntrepreneur?.info_consent_allowed
                    }
                    experienceInputRow={
                      selectedLightEntrepreneur?.workExperiences
                    }
                    pinned_fav_lightentrepreneur={
                      selectedLightEntrepreneur?.pinned_fav_lightentrepreneur
                    }
                    ratingsByCompany={selectedLERatings}
                  />
                </DialogContent>
                <DialogActions>
                  <div className="pull-right" style={{ paddingRight: '15px' }}>
                    <div>
                      <Button
                        variant="contained"
                        onClick={() => {
                          history.push('/dashboard/assignments')
                          offerAnAssignmentAgreement(selectedLightEntrepreneur)
                        }}
                        disabled={!selectedLightEntrepreneur?.IsOpenForWork}
                        style={{ float: 'right' }}
                      >
                        {t('employer.lightEntrepreneurs.button2')}
                      </Button>
                    </div>
                    {!selectedLightEntrepreneur?.IsOpenForWork && (
                      <p style={{ clear: 'both' }}>
                        {t('employer.lightEntrepreneurs.note')}
                      </p>
                    )}
                  </div>
                </DialogActions>
              </Dialog>
              <SnackbarComponent
                open={showSuccessAddSnackbar}
                onClose={() => {
                  closeLightEntrepreneursSnackbar()
                }}
                message={t('employer.lightEntrepreneurs.msg')}
                variant="success"
                autoHideDuration={2000}
              />
              <SnackbarComponent
                open={showFailedAddSnackbar}
                onClose={() => {
                  closeLightEntrepreneursSnackbar()
                }}
                message={t('employer.lightEntrepreneurs.msg1')}
                variant="error"
                autoHideDuration={3000}
              />
              <SnackbarComponent
                open={showAddFavouriteEntrepreneursFailedSnackbar}
                onClose={() => {
                  closeLightEntrepreneursSnackbar()
                }}
                message={t('employer.lightEntrepreneurs.msgAddFavFail')}
                variant="error"
                autoHideDuration={3000}
              />
              <SnackbarComponent
                open={showRemoveFavouriteEntrepreneursFailedSnackbar}
                onClose={() => {
                  closeLightEntrepreneursSnackbar()
                }}
                message={t('employer.lightEntrepreneurs.msgRemFavFail')}
                variant="error"
                autoHideDuration={3000}
              />
              <DialogBox
                classes={classes}
                isOpen={showEmailAdded}
                onClose={() => {
                  closeLightEntrepreneursSnackbar()
                }}
                title={t('employer.lightEntrepreneurs.dialogTitle3')}
                content={t('employer.lightEntrepreneurs.dialogContent3')}
                showCloseButton={true}
              />
              <DialogBox
                classes={classes}
                isOpen={showEmailNotExist}
                onClose={() => {
                  closeLightEntrepreneursSnackbar()
                }}
                title={t('employer.lightEntrepreneurs.dialogTitle2')}
                content={t('employer.lightEntrepreneurs.dialogContent2')}
                showCloseButton={true}
              />
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(LightEntrepreneursComponent)
